import copyToClipboard from 'copy-to-clipboard';
import moment from 'moment';
import Notifications from 'react-notification-system-redux';
import { adopted } from '../../../general/apiScenarios';
import { pagePathChanged } from '../../../general/modules/router/actions';
import { _select, _take, lm } from '../../listenerMiddleware';
import { logger } from '../../logger';
import { Page } from '../../models/page';
import { getPage } from '../app/selectors';
import * as fileManagerActions from '../fileManager/actions';
import { getNodeIDs, getSelectedNodesInAllFolders } from '../fileManager/selectors/selectors';
import * as sharingActions from './actions';
import { Messages, SharingShape, validateName } from './model';
import * as sharingSelectors from './selectors';
import {
  getNameWithDefault,
  getSelectedRange,
  getShareLink,
  getSharing,
  isSidebarEnabled,
  isSidebarExpanded,
} from './selectors';

export function sharingRootListener() {
  watchNewShareButtonClicked();
  watchCancelButtonClicked();
  watchSlipClicked();
  watchNameChangedUiEvent();
  watchGenShareLinkButtonClicked();
  watchClipboardButtonClicked();
  watchAppPagePathChanged();
  watchSidebarEnabled();
  watchSelectorChanged();
}

export function watchSelectorChanged() {
  lm.takeEvery(sharingActions.shareSelectorChanged, function (action, lapi) {
    const { node, shift, isChecked } = action.payload;
    if (shift) {
      lapi.dispatch(sharingActions.lastNodeIDSelectedChanged({ nodeID: node.id }));
      const range = _select(lapi, getSelectedRange);
      if (range) {
        const nodeIDsThisFolder = _select(lapi, getNodeIDs);
        const selectedNodes = _select(lapi, sharingSelectors.getShareSelectedNodes);
        const nodesOtherFolders = selectedNodes.filter((x) => !nodeIDsThisFolder.includes(x.id));
        const newNodes = [...nodesOtherFolders, ...range];
        lapi.dispatch(
          sharingActions.selectedNodesChanged({
            isSelected: isChecked,
            nodes: newNodes,
            replace: false,
          }),
        );
      }
    } else {
      lapi.dispatch(sharingActions.firstNodeIDSelectedChanged({ nodeID: node.id }));
      lapi.dispatch(
        sharingActions.selectedNodesChanged({
          isSelected: isChecked,
          nodes: [node],
          replace: false,
        }),
      );
    }
  });
}

export const watchSidebarEnabled = function () {
  lm.takeEvery(sharingActions.sidebarEnabled, function (action, lapi) {
    const selectedNodes = _select(lapi, getSelectedNodesInAllFolders);
    lapi.dispatch(sharingActions.shareSelectorAllChecked({ nodes: selectedNodes }));
    lapi.dispatch(fileManagerActions.allDeselected({}));
  });
};

export const watchNewShareButtonClicked = function () {
  lm.takeEvery(sharingActions.newShareButtonClicked, function (action, lapi) {
    const enabled: boolean = _select(lapi, isSidebarEnabled);
    if (!enabled) {
      lapi.dispatch(sharingActions.sidebarEnabled());
      lapi.dispatch(sharingActions.sidebarExpanded());
    }
  });
};

export const watchSlipClicked = function () {
  lm.takeEvery(sharingActions.slipClicked, function (action, lapi) {
    const isExpanded: boolean = _select(lapi, isSidebarExpanded);
    if (isExpanded) {
      lapi.dispatch(sharingActions.sidebarContracted());
    } else {
      lapi.dispatch(sharingActions.sidebarExpanded());
    }
  });
};

export const watchCancelButtonClicked = function () {
  lm.takeEvery(sharingActions.cancelButtonClicked, async function (action, lapi) {
    lapi.dispatch(sharingActions.sidebarContracted());
    await _take(lapi, sharingActions.sidebarHidden);
    if (lapi.signal.aborted) return;
    lapi.dispatch(sharingActions.sidebarDisabled());
  });
};

export const watchNameChangedUiEvent = function () {
  lm.takeEvery(sharingActions.nameChangedUiEvent, function (action, lapi) {
    const newName = validateName(action.payload.value, false);
    lapi.dispatch(sharingActions.shareNameChanged({ value: newName }));
  });
};

export const watchAppPagePathChanged = function () {
  lm.takeEvery(pagePathChanged, function (action, lapi) {
    const page = _select(lapi, getPage);
    const enabled = _select(lapi, isSidebarEnabled);
    if (page !== Page.FOLDER && page !== Page.SEARCH && enabled) {
      lapi.dispatch(sharingActions.sidebarDisabled());
    }
  });
};

export const watchGenShareLinkButtonClicked = function () {
  lm.takeEvery(sharingActions.genShareLinkButtonClicked, async function (action, lapi) {
    const shareName = _select(lapi, getNameWithDefault);
    lapi.dispatch(sharingActions.shareNameChanged({ value: shareName }));
    const share: SharingShape = _select(lapi, getSharing);
    try {
      lapi.dispatch(sharingActions.createShareStarted());

      const expireDate = moment()
        .add(share.doesNotExpire ? 99999 : share.expiresIn, 'day')
        .toISOString();
      const result = await adopted.sharingAPI.createShare(
        share.selectedNodes.map((n) => n.id),
        share.name,
        expireDate,
      );
      if (lapi.signal.aborted) return;
      logger.lapi(lapi, {
        action: 'Share',
        sub_action: 'Create',
        extra: { text_1: result.response.sharing.name, text_2: result.response.sharing.id },
      });
      lapi.dispatch(sharingActions.createShareSuccess(result));
      // lapi.dispatch(Notifications.success(Messages.createShareSuccess()));
    } catch (x) {
      lapi.dispatch(sharingActions.createShareError(x));
      lapi.dispatch(Notifications.error(Messages.createShareError()));
    }
  });
};

export const watchClipboardButtonClicked = function () {
  lm.takeEvery(sharingActions.clipboardButtonClicked, function (action, lapi) {
    const link = _select(lapi, getShareLink);
    copyToClipboard(link);
    // lapi.dispatch(Notifications.success(Messages.linkCopied()));
  });
};
